import { ReactElement, useState } from 'react'
import styled from 'styled-components'

import { IInputProps, Input } from 'components/Input'
import { VisibilityOffOutlineIcon } from 'components/Icons/VisibilityOffOutlineIcon'
import { VisibilityOutlineIcon } from 'components/Icons/VisibilityOutlineIcon'

const InputWrapper = styled.div`
  position: relative;

  input {
    padding-right: 25px;
  }
`

const ShowPasswordWrapper = styled.div`
  position: absolute;
  top: 13px;
  right: 10px;
  font-size: 13px;
  color: #1976d2;
  cursor: pointer;

  svg {
    fill: #aaa;
  }
`

export const InputPassword = (props: Omit<IInputProps<HTMLInputElement>, 'label'>): ReactElement => {
  const [isShowingPassword, showPassword] = useState(false)

  return (
    <InputWrapper>
      <Input type={isShowingPassword ? 'text' : 'password'} {...props} />
      <ShowPasswordWrapper onClick={(): void => showPassword(!isShowingPassword)}>
        {isShowingPassword ? <VisibilityOffOutlineIcon /> : <VisibilityOutlineIcon />}
      </ShowPasswordWrapper>
    </InputWrapper>
  )
}
